module.exports = function (btsUi) {
    'use strict';
    btsUi.directive('footerComponent', ["$rootScope", "$state", "$filter", "$window", "brand", "navigation", "sessionData", "teamsite", "taglines", "appId", "healthToolsService",
        function () {
            return {
                restrict: 'A',
                scope: {}
                //templateUrl: 'home.appTemplate.html/directives/footerComponent',
            };
        }]);
    btsUi.controller('footerController', ['$scope', "$state", "$filter", "$window", "brand", "navigation", "sessionData", "teamsite", "taglines", "appId", "healthToolsService", function ($scope, $state, $filter, $window, brand, navigation, sessionData, teamsite, taglines, appId, healthToolsService) {
        var REGIONAL_LANGUAGES_CONTENT_ID = 'REGIONAL_LANGUAGES',
            MBR_MEANINGFUL_ACCESS_LINK_ID = 'MBR_MEANINGFUL_ACCESS_LINK',
            APPROVAL_FOOTER_MESSAGE_BEGIN = "CMS_",
            APPROVAL_FOOTER_MESSAGE_END = "_FOOTER_MESSAGE",
            NON_DISCRIMINATION_POLICY_ID = "MBR_FOOTER_NON_DISCLOSURE";

        $scope.shouldShowLanguagesFooter = false;
        $scope.isFetchingLanguages = false;
        $scope.footer = false;

        // Set up scope variables for languages and meaningful-access link.
        $scope.languages = [];
        $scope.meaningfulAccessURL = null;
        $scope.targetUrl = window.location.origin;

        if ((window.location.href.indexOf("https://aem") != -1) || (window.location.href.indexOf("http://localhost:4502") != -1)) {
            $scope.footer = true;

        }

        if (sessionData.loggedIn || $scope.footer) {
            healthToolsService.populateModel();
        }

        $scope.showCCELink = healthToolsService.getCCEData();
        if ($scope.showCCELink) {
            $scope.targetCce = healthToolsService.getModel().targetCce;
        }
        var payPremiumData = healthToolsService.getPayPlanPremium();
        $scope.showPayPlanPremium = payPremiumData.showPayPlanPremium;
        $scope.payPremiumTargetUrl = payPremiumData.payPremiumTargetUrl;

        var populateFooterLanguagesMenu = function () {
            if ($scope.isFetchingLanguages) {
                return;
            }
            $scope.isFetchingLanguages = true;
            // Get Languages content from the taglines factory.
            $scope.languages = [];

            var allLanguages = {};
            taglines.getAllLanguages().then(
                function (result) {
                    allLanguages = result;
                }, function (/*error*/) {
                }
            ).finally(function () {
                    // Set up $scope.languages based off of teamsite.
                    teamsite.get(REGIONAL_LANGUAGES_CONTENT_ID).then(
                        function (response) {
                            var regionalLanguages = JSON.parse(response);
                            // For each langugage code in the languages property, ...
                            angular.forEach(regionalLanguages.languages, function (item) {
                                // ...if the language code is in allLanguages, ...
                                if (allLanguages[item]) {
                                    // ...push the language information from allLanguages into $scope.languages.
                                    $scope.languages.push(allLanguages[item]);
                                }
                            });

                            $scope.isFetchingLanguages = false;
                        }, function (/*error*/) {
                            $scope.isFetchingLanguages = false;
                        }
                    );
                });

            // Get the URL for the meaningful-access page from teamsite.
            teamsite.get(MBR_MEANINGFUL_ACCESS_LINK_ID).then(
                function (response) {
                    var languageLink = JSON.parse(response);
                    $scope.meaningfulAccessURL = languageLink.href;
                }, function (/*error*/) {
                }
            );
            teamsite.get(NON_DISCRIMINATION_POLICY_ID).then(
                function (response) {
                    var nonDiscriminationLink = JSON.parse(response);
                    $scope.nonDiscriminationURL = nonDiscriminationLink.href;
                }, function (/*error*/) {
                }
            );

        };

        $scope.session = sessionData;

        $scope.$watch("sessionData.loggedIn", function () {
            //$scope.shouldShowLanguagesFooter = $scope.isWYBCBS || $scope.isNDBCBS ? true : taglines.shouldShowLanguages($scope.session.appConfig, $scope.showLanguages);

            if (sessionData.loggedIn) {
                $scope.shouldShowLanguagesFooter = true;

                if ($scope.shouldShowLanguagesFooter) {
                    populateFooterLanguagesMenu();
                }
            }
        });
    }]);
};